var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMongo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6016 38C32.3335 38 38.6016 31.732 38.6016 24C38.6016 16.268 32.3335 10 24.6016 10C16.8696 10 10.6016 16.268 10.6016 24C10.6016 31.732 16.8696 38 24.6016 38Z",
    fill: "#13AA52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3438 22.2894C27.4595 18.3866 25.3696 17.1034 25.1446 16.6131C24.8985 16.2672 24.6491 15.652 24.6491 15.652C24.645 15.6416 24.6384 15.6232 24.6308 15.6055C24.6053 15.9514 24.5922 16.0848 24.2652 16.4337C23.7588 16.8296 21.1606 19.0098 20.9492 23.4438C20.7521 27.5793 23.9365 30.0435 24.3672 30.3577L24.4161 30.3924V30.3894C24.4189 30.4102 24.5528 31.3738 24.6469 32.3948H24.9843C25.0635 31.6731 25.1822 30.9562 25.3398 30.2475L25.3671 30.2297C25.5598 30.0916 25.7434 29.9414 25.917 29.7799L25.9367 29.7621C26.8522 28.9164 28.498 26.9602 28.4819 23.8414C28.4785 23.3212 28.4323 22.8021 28.3438 22.2894ZM24.6111 28.0228C24.6111 28.0228 24.6111 22.2227 24.8025 22.2237C24.9518 22.2237 25.1451 29.7053 25.1451 29.7053C24.8793 29.6733 24.6111 28.474 24.6111 28.0228Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongo);
export default __webpack_public_path__ + "static/media/mongo.793ae3910807cca67345f235ec061f65.svg";
export { ForwardRef as ReactComponent };